import { render } from "./StudioBadge.vue?vue&type=template&id=13b56156&ts=true"
import script from "./StudioBadge.vue?vue&type=script&lang=ts"
export * from "./StudioBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__